import React, { useCallback } from 'react';

import { Control } from 'react-hook-form';
import { theme } from '~/theme';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, MenuItem, Select, Stack, Typography } from '@mui/material';

import ArrayField from '../fields/ArrayField';

import { ACCORDION_SECTION_IDS, useAccordionExpanded } from './AccordionExpandedContext';

interface Props {
  control: Control<any>;
  schema: any;
}

const SECTION_ID = ACCORDION_SECTION_IDS.TAGS_AND_MARKETING;

const getArrayEnumOptions = (schema: any, fieldName: string): Array<string> =>
  schema?.properties?.[fieldName]?.items?.enum ?? [];

function TagsAndMarketingAccordion({ control, schema }: Props) {
  const { isSectionExpanded, toggleSection } = useAccordionExpanded();

  const handleAccordionChange = useCallback(() => {
    toggleSection(SECTION_ID);
  }, [toggleSection]);

  const locationOptions = getArrayEnumOptions(schema, 'locations');
  const holidayTypeOptions = getArrayEnumOptions(schema, 'holiday_types');
  const campaignOptions = getArrayEnumOptions(schema, 'campaigns');

  return (
    <Accordion expanded={isSectionExpanded(SECTION_ID)} onChange={handleAccordionChange} disableGutters>
      <AccordionSummary
        aria-controls="tags-and-marketing"
        expandIcon={<ExpandMoreIcon />}
        id="tags-and-marketing"
        sx={{
          backgroundColor: theme.palette.grey[200],
        }}
      >
        <Typography variant="h5">Tags & Marketing</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack mt={2} spacing={2}>
          <ArrayField
            control={control}
            label="Location Tags"
            name="locations"
            render={(props) => (
              <Select {...props} fullWidth>
                {locationOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          <ArrayField
            control={control}
            label="Holiday Type Tags"
            name="holiday_types"
            render={(props) => (
              <Select {...props} fullWidth>
                {holidayTypeOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          <ArrayField
            control={control}
            label="Campaign Tags"
            name="campaigns"
            render={(props) => (
              <Select {...props} fullWidth>
                {campaignOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}

export default TagsAndMarketingAccordion;
